import Button from '../../../atoms/button';
import PropTypes from 'prop-types';
import React from 'react';

import { TriangleDown, CarretArrowLeft } from '../../../atoms/icons';
import styles from './AccountHeader.module.scss';
import { theme } from './_vars';

const AccountHeader = ({ title, action }) => {
  return (
    <span className={styles.headerContainer}>
      <Button variant="primary" as="text" onClick={action}>
        {theme === 'Jag' ? (
          <TriangleDown className={styles.iconArrow} />
        ) : (
          <CarretArrowLeft className={styles.iconArrow} />
        )}
      </Button>
      <h1 className={styles.headerTitle}>{title}</h1>
      <div className={styles.emptyBlock} />
    </span>
  );
};

AccountHeader.propTypes = {
  title: PropTypes.string,
  action: PropTypes.func,
  className: PropTypes.string,
};

AccountHeader.defaultProps = {
  title: '',
  action: () => {},
  className: '',
};

export default AccountHeader;
